"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rating = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _internal = require("../../hooks/internal");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Rating = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    code,
    hideRating,
    rating,
    ratingCount
  } = (0, _internal.useProduct)();
  if (hideRating) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StarRating, {
      value: rating,
      max: 5,
      showTextRating: false,
      "data-testid": `${getTestId(_constants.RATING)}-${code}`
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      variant: "overline",
      color: "textPrimary",
      fontWeight: "bold",
      children: ["(", ratingCount, ")"]
    })]
  });
};
exports.Rating = Rating;
//# sourceMappingURL=Rating.js.map